import { Inject, Injectable } from '@angular/core';
import { STORAGE } from './storage.token';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  constructor(@Inject(STORAGE) private localStorage: Storage) {}

  get<T>(key: string): T {
    return JSON.parse(this.localStorage.getItem(key)) as T;
  }

  set<T>(key: string, value: T) {
    this.localStorage.setItem(key, JSON.stringify(value));
  }

  remove(key: string) {
    this.localStorage.removeItem(key);
  }
}
